import React from "react";
import PageContainer from "../components/PageContainer";
import ManageUsers from "./ManageUsers";

const UserManagement: React.FC = () => {
  return (
    <PageContainer sx={{ mt: 2 }}>
      <ManageUsers />
    </PageContainer>
  );
};

export default UserManagement;
